angular.module('controllers').controller('appApiController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud) {
		$rootScope.path = '/app-api';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'app-api';
		$scope.pathTemplate = 'app/appapis';
		$scope.title = 'Api-uri';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'api_client';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'api_client':{'label':'Client', 'filter':1, 'filterType':'input'},
			'api_ip':{'label':'Ip', 'filter':1, 'filterType':'input'},
			'api_username':{'label':'Username', 'filter':1, 'filterType':'input'},
			'api_password':{'label':'Parola', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		$scope.additionals = [];
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'api_client';


	}]
);
